// extracted by mini-css-extract-plugin
export default {"root":"NavTabs_root__aKL65","tabs":"NavTabs_tabs__Ah6wj"};